import { ca } from '@cian/analytics';

interface ITrackPinClickParameters {
  isDetailsVisible: boolean;
  offerId?: number;
  zoom: number;
}

export function trackPinClick({ offerId, zoom }: ITrackPinClickParameters) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click_pin',
    category: 'Map',
    label: `blue/${zoom}`,
    page: {
      queryString: window.location.search,
    },
    products: [{ id: offerId }],
  });
}
